import {graphql, useStaticQuery} from "gatsby";

/**
 * Hook to return all available modules.
 *
 * @returns {import('../repository/EntityRepository.js').Module[]} - An array of modules.
 */
export const useAllModules = () => {
  const { allStrapiModules: { nodes } } = useStaticQuery(graphql`
      query {                
          allStrapiModules {
              nodes {
                  name
                  configJSON
                  srcs {
                      name
                      content
                  }
              }
              
          }
      }
    `);
  return nodes
}
